import { useCallback, useEffect, useMemo, useState } from 'react';
import { UserService } from 'layouts/pages/System/users/services/user.service';
import { UserResponse } from 'layouts/pages/System/users/services/responses/user.response';

/// Quem pode receber lead: só os ativos, pois passar para quem não entra mais o deixa parado.
export const useCrmUsers = () => {
    const [users, setUsers] = useState<UserResponse[]>([]);
    const service = useMemo(() => new UserService(), []);

    const fetchAll = useCallback(async () => {
        try {
            const res = await service.paginated(1, 200);

            setUsers((res.data.data?.records ?? []).filter((u) => u.active));
        } catch (e) {
            console.error(e);
        }
    }, [service]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    return { users, refetch: fetchAll };
};
